import { INavPageitemDockZonesOptions, constants, NavPageitemDockZones, NavItemsGrid } from '../../navkendo';
import { SessionEvents } from '@common/rwf/rwfedit.common';
import { NavDock, NavDockHoverShow } from '../../navkendo/navdock';
import { RwfBootstrap } from '@common/rwf';
import { NavClientService, Observable, IViewPageDisplay } from '@common/navdata';
import { CompatibilityService } from '@common/services/compatibilityservice';
import { NavSettingsService } from '@common/services/settingsservice';
import { fn } from '@common/utils';
import { ExternalViewProxy } from '@common/preview/preview.shared';
import { ExternalView } from '@common/preview/externalpreview';

export abstract class CtrlPageItemView extends Observable {
    private static _Template: string = require("./pageitemview.html");
    static Template(id: string) { return  this._Template.replace("$$id$$", id); }
    constructor(private $scope: ng.IScope, protected $c: CompatibilityService,
        protected $rwf: RwfBootstrap, protected NavClient: NavClientService,
        public NavSettings: NavSettingsService, extid: string) {
        super();

        $scope.$on("$destroy", () => this.trigger(constants.NavDestroy));

        if (extid) {
            // It's an 'externally controlled Instance!
            this.ExternalViewProxy = new ExternalViewProxy(extid, true);

            var origTitle = document.title;
            $scope.$watch(() => this.CurrentTitle, newVal => {
                document.title = newVal || origTitle;
            });
        }

        let baseAction = actCopyCurrentRowContext && actCopyCurrentRowContext.Grid && actCopyCurrentRowContext.Grid.CurrentItems.CopySelectionAction;
        var actCopyCurrentRowContext = this.CopyCurrentRowContent = {
            Grid: <NavItemsGrid>undefined,
            get Enabled() { return !!(baseAction && baseAction.Enabled); },
            get Title() { return baseAction && baseAction.Title || 'Zelle kopieren'; },
            get Hint() { return baseAction && baseAction.Hint || ''; },

            SetContext: (e: JQueryEventObject) => {
                const grid: NavItemsGrid = actCopyCurrentRowContext.Grid = $(e.target).parents(':data(kendoNavItemsGrid)').data('kendoNavItemsGrid');
                // TODO : adjust context from click event ...
                baseAction = grid && grid.CurrentItems && grid.CurrentItems.CopySelectionAction;
                $scope.$applyAsync();
            },
            Execute: () => {
                return baseAction && baseAction.Execute();
            }
        };
    }

    public View: IViewPageDisplay;
    public ZonesOptions: INavPageitemDockZonesOptions;
    public Show = false;

    public abstract readonly PageName: string;

    public CurrentTitle = "";

    public Error = "";

    /** attached from view */
    public readonly DockZones?: NavPageitemDockZones;

    /** Set if its an externally controlled 'salve' Instance (Undocked), controlled from Master */
    public readonly ExternalViewProxy?: ExternalViewProxy;

    /** Get Url to open in external View */
    protected GetExternalUrl?: (extId: string) => string;

    /** to be called when rendered in dockzones: Bind resizing actions */
    protected onRenderedInDockZone(root: JQuery) {
        const dockZones = root.data('kendoNavPageitemDockZones');
        if (dockZones) {
            let registerRefreshOnHoverShow = () => {
                const pDock = NavDock.GetParentDock(root);
                if (pDock) {
                    pDock.bind(NavDockHoverShow, refreshHeight);

                    pDock.bind(constants.ExpansionStateChanged, () => {
                        const _externalView = this._externalView;
                        if (_externalView) {
                            if (!pDock.IsCollapsed()) {
                                _externalView.IsActive = false;
                            }
                        } else {
                            refreshHeight();
                        }
                    });

                    registerRefreshOnHoverShow = fn.noop;
                }
            };
            const refreshHeight = () => {
                registerRefreshOnHoverShow();
                var dockSizes = dockZones.GetDocks().toArray().map(d => {
                    const dock = $(d);
                    return dock.height() + dock.position().top;
                });
                const maxDockSize = Math.max(...dockSizes);

                if (maxDockSize > 0) {
                    dockZones.element.height((maxDockSize + 20) + "px");
                    if (this.ExternalViewProxy) {
                        window.resizeTo(window.outerWidth + 10, maxDockSize + 20 + 90);
                    }
                }
            };
            dockZones.bind(constants.ExpansionStateChanged, refreshHeight);
            this.bind(SessionEvents.displaychange, refreshHeight);

            return refreshHeight();
        }
    }

    /** Undock Item View */
    public readonly UndockItemView = {
        Hint: "In separates Fenster abdocken/Abgedocktes Fenster andocken",
        Icon: 'idms_Icon_UnDock',
        Execute: () => {
            let extView = this._externalView;
            if (!extView) {
                this._externalView = extView = new ExternalView(undefined,
                    () => this.GetExternalUrl(extView.Identifier),
                    this.CurrentTitle);
                this.bind(constants.NavDestroy, () => extView.IsActive = false);
            }

            if (extView.IsActive = !extView.IsActive) {
                return extView.EnsureAlive(<any>{ x: 100, y: 100, width: 800, height: 600 }).then(alive => {
                    if (this.DockZones) {
                        var dock = NavDock.GetParentDock(this.DockZones.element);
                        if (dock) {
                            dock.Collapse();
                        }
                    }
                });
            }
        }
    };

    protected _externalView: ExternalView;

    public readonly CopyCurrentRowContent;
}
